import React from 'react';

const UserInformation = ({ user, onMenuClick }) => {
  let userStyle = {};
  if (!onMenuClick) {
    userStyle.right = 30;
  }
  //console.log("user", user);
  return (
    <div
      className="no-print"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        height: '100%',
        marginRight: 30
      }}
    >
      <div className="user" style={userStyle}>
        <div className="name">{user.name || ' '}</div>
        {user.sub && <div className="company">({user.s_name})</div>}
      </div>
      {onMenuClick && (
        <div
          className="icon-arrow-down5 text-24 cursor-pointer"
          onClick={onMenuClick}
          style={{ marginLeft: 10 }}
        />
      )}
    </div>
  );
};

export default UserInformation;
